        <!-- HJ212Stat HJ212图形报表 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="hJ212Stat">
      <div class="hJ212Stat_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>HJ212图形报表</h1>
      <div class="hJ212Stat_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="graphics_search clearfix">
      <div class="graphics_box fl" v-show="options.length > 0">
        <span class="fl">归属机构：</span>
        <el-cascader
          class="fl"
          :clearable="true"
          v-model="value"
          :checkStrictly="true"
          :options="options"
          placeholder="系统管理机构"
          filterable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          @change="handleChange"
        ></el-cascader>
      </div>
      <div class="graphics_box fl">
        <span class="fl">采集点：</span>
        <el-select class="fl" v-model="deviceId" placeholder="请选择">
          <el-option
            v-for="item in patchLists"
            :key="item.value"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="graphics_box fl">
        <el-button
          class="fl"
          type="primary"
          @click="queryClick()"
          icon="el-icon-search"
          >查询</el-button
        >
      </div>
      <div class="graphics_box fl" v-show="false">
        <el-button
          class="fl"
          type="success"
          icon="el-icon-upload2"
          @click="exportClick()"
          >导出</el-button
        >
      </div>
    </div>

    <el-divider></el-divider>
    <div id="charts" class="chart_box"></div>
    <el-divider></el-divider>
    <div id="chartsMonth" class="chart_box"></div>
    <el-divider></el-divider>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
import { JSONToExcelConvertor } from "../../assets/js/excel";
export default {
  data() {
    return {
      // 监听窗口变化
      screenWidth: document.body.clientWidth,
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 归属机构ID
      deptId: "",
      // 当前机构LIST
      value: [],
      // 机构树
      options: [],
      //  采集点
      deviceId: "",
      //  采集点list
      patchLists: [],

      legendData: "",
      series: "",
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取结构树
    this.options = JSON.parse(localStorage.getItem("structure"));
  },

  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timers) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timers = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(that.screenWidth);

          if (that.deviceId !== "") {
            that.HJ212Stat(that.deviceId);
            that.HJ212Month(that.deviceId);
          }

          that.timers = false;
        }, 400);
      }
    },
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };

    let title = {};
    title.text = "系统管理机构";
    title.subtext = "暂无数据";
    // 当天统计图表 初始化
    this.chartsBox(title, [], []);

    var dateTime = new Date();
    let n = dateTime.getFullYear();
    let y = dateTime.getMonth() + 1;

    var d = new Date(n, y, 0);
    let tians = d.getDate();

    let list = [];
    for (let i = 0; i < tians; i++) {
      list.push(i + 1 + "日");
    }

    this.chartsMonth(title, [], list, []);

    if (localStorage.getItem("loginToken")) {
      // 初始化采集点
      this.HJ212Records("");
    }
  },
  methods: {
    fn(num) {
      let loginToken = localStorage.getItem("loginToken");
      var jo = {
        txcode: "HJ212Stat",
        option: "DOWNLOAD",
        deviceId: this.deviceId,
        precision: num,
        beginDate: "",
        endDate: "",
        loginToken: loginToken,
      };
      let url = this.api;
      url = url.replace("/DipoJson.cgi", "/DipoView.cgi"); //导出时需要把DipoJson换成DipoView
      var form = $("<form id='tempform' name='tempform'></form>")
        .attr("action", url)
        .attr("method", "post")
        // .attr("target", "rfFrame");
        .attr("target", "footframe");
      for (var key in jo) {
        form.append(
          $("<input></input>")
            .attr("type", "hidden")
            .attr("name", key)
            .attr("value", jo[key])
        );
      }
      form.appendTo("body").submit().remove();
    },
    // 导出
    exportClick() {
      if (this.series.length == 0) {
        this.$message({
          message: "暂无数据！",
          type: "warning",
        });
        return;
      } else {
        this.fn("0");
      }
      // let arr = [];
      // for (let i = 0; i < this.legendData.length; i++) {
      //   arr.push({
      //     keys: this.legendData[i].split("/")[0],
      //     value: this.legendData[i],
      //   });
      // }
      // arr.push({
      //   keys: "time",
      //   value: "记录时间",
      // });

      // let list = [];
      // for (let i = 0; i < 24; i++) {
      //   (function (i) {
      //     let at = {};
      //     for (let j = 0; j < arr.length; j++) {
      //       at[arr[j].keys] = "";
      //     }
      //     list.push(at);
      //   })(i);
      // }

      // let _this = this;
      // for (let i = 0; i < this.series.length; i++) {
      //   (function (i) {
      //     for (let j = 0; j < arr.length; j++) {
      //       if (_this.series[i].name == arr[j].value) {
      //         (function (i, j) {
      //           for (let k = 0; k < _this.series[i].data.length; k++) {
      //             if (_this.series[i].data[k] == "") {
      //               list[k][arr[j].keys] = "99999999";
      //             } else {
      //               list[k][arr[j].keys] = _this.series[i].data[k];
      //             }
      //           }
      //         })(i, j);
      //       }
      //     }
      //   })(i);
      // }

      // var timeDate = new Date();
      // var n = timeDate.getFullYear();
      // var y = timeDate.getMonth() + 1;
      // var r = timeDate.getDate();

      // y = y > 9 ? y : "0" + y;
      // r = r > 9 ? r : "0" + r;

      // for (let i = 0; i < list.length; i++) {
      //   (function (i) {
      //     list[i].time = n + "-" + y + "-" + r + " " + (i > 9 ? i : "0" + i);
      //   })(i);
      // }
      // let s =
      //   timeDate.getHours() > 9
      //     ? timeDate.getHours()
      //     : "0" + timeDate.getHours();
      // let f =
      //   timeDate.getMinutes() > 9
      //     ? timeDate.getMinutes()
      //     : "0" + timeDate.getMinutes();
      // let m =
      //   timeDate.getSeconds() > 9
      //     ? timeDate.getSeconds()
      //     : "0" + timeDate.getSeconds();

      // let textName = "HJ212图形报表_" + n + y + r + s + f + m;

      // var values = "";
      // for (let i = 0; i < this.patchLists.length; i++) {
      //   if (this.patchLists[i].deviceId == this.deviceId) {
      //     values = this.patchLists[i].deviceName;
      //     break;
      //   }
      // }

      // JSONToExcelConvertor(values, arr, list, textName);
    },
    // 当天统计图表
    chartsBox(title, legendData, series) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("charts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("charts"));

      // 指定图表的配置项和数据
      var option = {
        title,
        tooltip: {
          trigger: "axis",
        },
        grid: {
          y: 120,
        },
        legend: {
          data: legendData,
          y: "38px",
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
              "7时",
              "8时",
              "9时",
              "10时",
              "11时",
              "12时",
              "13时",
              "14时",
              "15时",
              "16时",
              "17时",
              "18时",
              "19时",
              "20时",
              "21时",
              "22时",
              "23时",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series,
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 当月统计图表
    chartsMonth(title, legendData, xAxis, series) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("chartsMonth"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("chartsMonth"));

      // 指定图表的配置项和数据
      var option = {
        title,
        tooltip: {
          trigger: "axis",
        },
        grid: {
          y: 120,
        },
        legend: {
          data: legendData,
          y: "38px",
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xAxis,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series,
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    // 获取机构下的采集点
    HJ212Records(deptId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Records",
          deptId,
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            // 获取机构下的采集点
            this.patchLists = res.data.devices;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 小时 报表查询（HJ212汇总统计）
    HJ212Stat(deviceId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Stat", //交易码
          option: "STAT", //交易选项，不填则返回设备列表，填DOWNLOAD表示导出数据文件。
          deviceId, //设备ID（必填）
          precision: "0", //统计时间尺度（0单日各时，1单月各天）
          beginDate: "",
          endDate: "",
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.list !== []) {
              let nameToDesc = res.data.nameToDesc;
              let list = res.data.list;

              let series = [];
              for (let key in nameToDesc) {
                if (key !== "ST" && key !== "CN" && key !== "DataTime") {
                  (function (key) {
                    let vd = {
                      name: key + "/" + nameToDesc[key],
                      type: "line",
                      smooth: true,
                      data: [],
                    };
                    for (let i = 0; i < list.length; i++) {
                      if (list[i][key] == "999999.00") {
                        vd.data.push("");
                      } else {
                        vd.data.push(list[i][key]);
                      }
                    }
                    series.push(vd);
                  })(key);
                }
              }

              let legendData = [];
              for (let i = 0; i < series.length; i++) {
                legendData.push(series[i].name);
              }

              let title = {};
              title.text = res.data.deviceName;
              if (series.length == 0) {
                title.subtext = "暂无数据";
              } else {
                title.subtext = "";
              }

              this.legendData = legendData;
              this.series = series;

              this.chartsBox(title, legendData, series);
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 天 报表查询（HJ212汇总统计）
    HJ212Month(deviceId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Stat", //交易码
          option: "STAT", //交易选项，不填则返回设备列表，填DOWNLOAD表示导出数据文件。
          deviceId, //设备ID（必填）
          precision: "1", //统计时间尺度（0单日各时，1单月各天）
          beginDate: "",
          endDate: "",
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.list !== []) {
              let nameToDesc = res.data.nameToDesc;
              let list = res.data.list;

              let series = [];
              for (let key in nameToDesc) {
                if (key !== "ST" && key !== "CN" && key !== "DataTime") {
                  (function (key) {
                    let vd = {
                      name: key + "/" + nameToDesc[key],
                      type: "line",
                      smooth: true,
                      data: [],
                    };
                    for (let i = 0; i < list.length; i++) {
                      if (list[i][key] == "999999.00") {
                        vd.data.push("");
                      } else {
                        vd.data.push(list[i][key]);
                      }
                    }
                    series.push(vd);
                  })(key);
                }
              }

              let legendData = [];
              for (let i = 0; i < series.length; i++) {
                legendData.push(series[i].name);
              }

              let title = {};
              title.text = res.data.deviceName;
              if (series.length == 0) {
                title.subtext = "暂无数据";
              } else {
                title.subtext = "";
              }

              let xAxis = [];
              for (let i = 0; i < list.length; i++) {
                xAxis.push(i + 1 + "日");
              }
              // console.log(xAxis);

              // console.log(title, legendData,xAxis, series)
              this.chartsMonth(title, legendData, xAxis, series);
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询数据
    queryClick() {
      if (this.deviceId !== "") {
        this.HJ212Stat(this.deviceId);
        this.HJ212Month(this.deviceId);
      } else {
        this.$message({
          message: "采集点不能为空！",
          type: "warning",
        });
      }
    },
    // 现在所属机构
    handleChange(value) {
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
      // 获取采集点
      this.HJ212Records(this.deptId);
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.hJ212Stat {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .hJ212Stat_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .hJ212Stat_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.graphics_search {
  width: 100%;
  min-height: 60px;
  margin-top: 10px;
  .graphics_box {
    height: 40px;
    line-height: 40px;
    margin: 10px 15px 10px 15px;
  }
}

.chart_box {
  width: calc(100% - 40px);
  height: 500px;
  margin: 10px 20px;
  margin-top: 20px;
  background-color: #fff;
}
</style>
